// نظام ألوان شامل للأفاتار - 200 لون قاتم ومعتدل
export const AVATAR_COLORS = [
  // ألوان أساسية قاتمة ومعتدلة
  "#E53E3E", // أحمر قاتم
  "#38A169", // أخضر قاتم
  "#3182CE", // أزرق قاتم
  "#805AD5", // بنفسجي قاتم
  "#D69E2E", // برتقالي قاتم
  "#DD6B20", // برتقالي محترق
  "#2D3748", // رمادي داكن
  "#4A5568", // رمادي معتدل
  "#2B6CB0", // أزرق داكن
  "#2F855A", // أخضر داكن

  // ألوان زرقاء قاتمة ومعتدلة
  "#1A365D", // أزرق داكن جداً
  "#2C5282", // أزرق داكن
  "#2B6CB0", // أزرق معتدل
  "#3182CE", // أزرق متوسط
  "#4299E1", // أزرق فاتح معتدل
  "#1E3A8A", // أزرق داكن
  "#1E40AF", // أزرق داكن
  "#2563EB", // أزرق متوسط
  "#3B82F6", // أزرق معتدل
  "#60A5FA", // أزرق فاتح معتدل

  // ألوان خضراء قاتمة ومعتدلة
  "#1A202C", // أخضر داكن جداً
  "#2D3748", // أخضر داكن
  "#4A5568", // أخضر معتدل
  "#68D391", // أخضر فاتح معتدل
  "#48BB78", // أخضر متوسط
  "#38A169", // أخضر قاتم
  "#2F855A", // أخضر داكن
  "#276749", // أخضر داكن جداً
  "#22543D", // أخضر داكن جداً
  "#1C4532", // أخضر داكن جداً

  // ألوان حمراء قاتمة ومعتدلة
  "#742A2A", // أحمر داكن جداً
  "#9B2C2C", // أحمر داكن
  "#C53030", // أحمر معتدل
  "#E53E3E", // أحمر متوسط
  "#FC8181", // أحمر فاتح معتدل
  "#F56565", // أحمر فاتح معتدل
  "#E53E3E", // أحمر قاتم
  "#C53030", // أحمر داكن
  "#9B2C2C", // أحمر داكن جداً
  "#742A2A", // أحمر داكن جداً

  // ألوان بنفسجية قاتمة ومعتدلة
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل

  // ألوان برتقالية قاتمة ومعتدلة
  "#C05621", // برتقالي داكن
  "#DD6B20", // برتقالي معتدل
  "#ED8936", // برتقالي متوسط
  "#F6AD55", // برتقالي فاتح معتدل
  "#FBD38D", // برتقالي فاتح معتدل
  "#C05621", // برتقالي داكن
  "#DD6B20", // برتقالي معتدل
  "#ED8936", // برتقالي متوسط
  "#F6AD55", // برتقالي فاتح معتدل
  "#FBD38D", // برتقالي فاتح معتدل

  // ألوان رمادية قاتمة ومعتدلة
  "#1A202C", // رمادي داكن جداً
  "#2D3748", // رمادي داكن
  "#4A5568", // رمادي معتدل
  "#718096", // رمادي متوسط
  "#A0AEC0", // رمادي فاتح معتدل
  "#CBD5E0", // رمادي فاتح معتدل
  "#E2E8F0", // رمادي فاتح معتدل
  "#F7FAFC", // رمادي فاتح جداً معتدل
  "#1A202C", // رمادي داكن جداً
  "#2D3748", // رمادي داكن

  // ألوان زرقاء داكنة إضافية
  "#1A365D", // أزرق داكن جداً
  "#2C5282", // أزرق داكن
  "#2B6CB0", // أزرق معتدل
  "#3182CE", // أزرق متوسط
  "#4299E1", // أزرق فاتح معتدل
  "#1E3A8A", // أزرق داكن
  "#1E40AF", // أزرق داكن
  "#2563EB", // أزرق متوسط
  "#3B82F6", // أزرق معتدل
  "#60A5FA", // أزرق فاتح معتدل

  // ألوان خضراء داكنة إضافية
  "#1A202C", // أخضر داكن جداً
  "#2D3748", // أخضر داكن
  "#4A5568", // أخضر معتدل
  "#68D391", // أخضر فاتح معتدل
  "#48BB78", // أخضر متوسط
  "#38A169", // أخضر قاتم
  "#2F855A", // أخضر داكن
  "#276749", // أخضر داكن جداً
  "#22543D", // أخضر داكن جداً
  "#1C4532", // أخضر داكن جداً

  // ألوان حمراء داكنة إضافية
  "#742A2A", // أحمر داكن جداً
  "#9B2C2C", // أحمر داكن
  "#C53030", // أحمر معتدل
  "#E53E3E", // أحمر متوسط
  "#FC8181", // أحمر فاتح معتدل
  "#F56565", // أحمر فاتح معتدل
  "#E53E3E", // أحمر قاتم
  "#C53030", // أحمر داكن
  "#9B2C2C", // أحمر داكن جداً
  "#742A2A", // أحمر داكن جداً

  // ألوان بنفسجية داكنة إضافية
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل

  // ألوان برتقالية داكنة إضافية
  "#C05621", // برتقالي داكن
  "#DD6B20", // برتقالي معتدل
  "#ED8936", // برتقالي متوسط
  "#F6AD55", // برتقالي فاتح معتدل
  "#FBD38D", // برتقالي فاتح معتدل
  "#C05621", // برتقالي داكن
  "#DD6B20", // برتقالي معتدل
  "#ED8936", // برتقالي متوسط
  "#F6AD55", // برتقالي فاتح معتدل
  "#FBD38D", // برتقالي فاتح معتدل

  // ألوان إضافية متنوعة قاتمة ومعتدلة
  "#744210", // بني داكن
  "#975A16", // بني معتدل
  "#B7791F", // بني متوسط
  "#D69E2E", // بني فاتح معتدل
  "#F6E05E", // بني فاتح معتدل
  "#744210", // بني داكن
  "#975A16", // بني معتدل
  "#B7791F", // بني متوسط
  "#D69E2E", // بني فاتح معتدل
  "#F6E05E", // بني فاتح معتدل

  // ألوان زرقاء معتدلة إضافية
  "#1A365D", // أزرق داكن جداً
  "#2C5282", // أزرق داكن
  "#2B6CB0", // أزرق معتدل
  "#3182CE", // أزرق متوسط
  "#4299E1", // أزرق فاتح معتدل
  "#1E3A8A", // أزرق داكن
  "#1E40AF", // أزرق داكن
  "#2563EB", // أزرق متوسط
  "#3B82F6", // أزرق معتدل
  "#60A5FA", // أزرق فاتح معتدل

  // ألوان خضراء معتدلة إضافية
  "#1A202C", // أخضر داكن جداً
  "#2D3748", // أخضر داكن
  "#4A5568", // أخضر معتدل
  "#68D391", // أخضر فاتح معتدل
  "#48BB78", // أخضر متوسط
  "#38A169", // أخضر قاتم
  "#2F855A", // أخضر داكن
  "#276749", // أخضر داكن جداً
  "#22543D", // أخضر داكن جداً
  "#1C4532", // أخضر داكن جداً

  // ألوان حمراء معتدلة إضافية
  "#742A2A", // أحمر داكن جداً
  "#9B2C2C", // أحمر داكن
  "#C53030", // أحمر معتدل
  "#E53E3E", // أحمر متوسط
  "#FC8181", // أحمر فاتح معتدل
  "#F56565", // أحمر فاتح معتدل
  "#E53E3E", // أحمر قاتم
  "#C53030", // أحمر داكن
  "#9B2C2C", // أحمر داكن جداً
  "#742A2A", // أحمر داكن جداً

  // ألوان بنفسجية معتدلة إضافية
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل
  "#553C9A", // بنفسجي داكن
  "#6B46C1", // بنفسجي معتدل
  "#805AD5", // بنفسجي متوسط
  "#9F7AEA", // بنفسجي فاتح معتدل
  "#B794F6", // بنفسجي فاتح معتدل
];

// دالة للحصول على لون فريد بناءً على معرف المستخدم
export const getAvatarColorById = (userId) => {
  if (!userId) return AVATAR_COLORS[0];

  // استخدام معرف المستخدم لتحديد اللون
  const colorIndex = userId % AVATAR_COLORS.length;
  return AVATAR_COLORS[colorIndex];
};

// دالة للحصول على لون فريد بناءً على معرف المستخدم مع ضمان التوزيع المتساوي
export const getAvatarColorByHash = (userId) => {
  if (!userId) return AVATAR_COLORS[0];

  // تحويل معرف المستخدم إلى hash
  let hash = 0;
  const str = userId.toString();
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // تحويل إلى 32-bit integer
  }

  // استخدام القيمة المطلقة للhash لتحديد اللون
  const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[colorIndex];
};
